// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet crm-public API
 * OpenAPI spec version: 1
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, toValue, unref } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

import type { CollectionResultOfCrmRelationsGetRechtsvormOptiesDto } from '../model/collectionResultOfCrmRelationsGetRechtsvormOptiesDto.ts';

import type { CollectionResultOfCrmRelationsLoggingRelatieLog } from '../model/collectionResultOfCrmRelationsLoggingRelatieLog.ts';

import type { CollectionResultOfCrmRelationsZoekRelatiesByDto } from '../model/collectionResultOfCrmRelationsZoekRelatiesByDto.ts';

import type { CollectionResultOfSUREbusinessCCSPublisherFeaturesRelatieFindRelatiesDto } from '../model/collectionResultOfSUREbusinessCCSPublisherFeaturesRelatieFindRelatiesDto.ts';

import type { CrmRelationsParticuliereRelatieDto } from '../model/crmRelationsParticuliereRelatieDto.ts';

import type { CrmRelationsZakelijkeRelatieDto } from '../model/crmRelationsZakelijkeRelatieDto.ts';

import type { RelatiesGetByParams } from '../model/relatiesGetByParams.ts';

import type { RelatiesGetOverzichtCountParams } from '../model/relatiesGetOverzichtCountParams.ts';

import type { RelatiesGetOverzichtParams } from '../model/relatiesGetOverzichtParams.ts';

import type { RelatiesGetOverzichtUitgebreidCountParams } from '../model/relatiesGetOverzichtUitgebreidCountParams.ts';

import type { RelatiesGetOverzichtUitgebreidParams } from '../model/relatiesGetOverzichtUitgebreidParams.ts';

import type { Result1OfCrmRelationsGetRelatieKredietstatusDto } from '../model/result1OfCrmRelationsGetRelatieKredietstatusDto.ts';

import type { Result1OfCrmRelationsRelationDto } from '../model/result1OfCrmRelationsRelationDto.ts';

import type { Result1OfManagementModelsEmpty } from '../model/result1OfManagementModelsEmpty.ts';

import type { Result1OfSystemInt32 } from '../model/result1OfSystemInt32.ts';

import { customInstance } from '../../customInstance.ts';
import type { ErrorType } from '../../customInstance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.RelatieInzien</li></ul>
 * @summary Haal een specifieke relatie op op basis van een relatienummer.
 */
export const relatiesGetRelationByRelatienummer = (
  relatienummer: MaybeRefOrGetter<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  relatienummer = toValue(relatienummer);

  return customInstance<Result1OfCrmRelationsRelationDto>(
    { url: `/api/v1/relaties/${relatienummer}`, method: 'GET', signal },
    options,
  );
};

export const getRelatiesGetRelationByRelatienummerQueryKey = (
  relatienummer: MaybeRefOrGetter<number | undefined | null>,
) => {
  return ['api', 'v1', 'relaties', relatienummer] as const;
};

export const getRelatiesGetRelationByRelatienummerQueryOptions = <
  TData = Awaited<ReturnType<typeof relatiesGetRelationByRelatienummer>>,
  TError = ErrorType<void>,
>(
  relatienummer: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof relatiesGetRelationByRelatienummer>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getRelatiesGetRelationByRelatienummerQueryKey(relatienummer);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof relatiesGetRelationByRelatienummer>>> = ({
    signal,
  }) => relatiesGetRelationByRelatienummer(relatienummer, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(
      () => toValue(relatienummer) !== null && toValue(relatienummer) !== undefined,
    ),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof relatiesGetRelationByRelatienummer>>,
    TError,
    TData
  >;
};

export type RelatiesGetRelationByRelatienummerQueryResult = NonNullable<
  Awaited<ReturnType<typeof relatiesGetRelationByRelatienummer>>
>;
export type RelatiesGetRelationByRelatienummerQueryError = ErrorType<void>;

/**
 * @summary Haal een specifieke relatie op op basis van een relatienummer.
 */

export function useRelatiesGetRelationByRelatienummer<
  TData = Awaited<ReturnType<typeof relatiesGetRelationByRelatienummer>>,
  TError = ErrorType<void>,
>(
  relatienummer: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof relatiesGetRelationByRelatienummer>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRelatiesGetRelationByRelatienummerQueryOptions(relatienummer, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.RelatieBijwerken</li></ul>
 * @summary Muteer een relatie.
 */
export const relatiesMuteerRelatieById = (
  relatienummer: MaybeRefOrGetter<number | undefined | null>,
  crmRelationsZakelijkeRelatieDtoCrmRelationsParticuliereRelatieDto?: MaybeRefOrGetter<
    CrmRelationsZakelijkeRelatieDto | CrmRelationsParticuliereRelatieDto
  >,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  relatienummer = toValue(relatienummer);
  crmRelationsZakelijkeRelatieDtoCrmRelationsParticuliereRelatieDto = toValue(
    crmRelationsZakelijkeRelatieDtoCrmRelationsParticuliereRelatieDto,
  );

  return customInstance<void>(
    {
      url: `/api/v1/relaties/${relatienummer}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: crmRelationsZakelijkeRelatieDtoCrmRelationsParticuliereRelatieDto,
      signal,
    },
    options,
  );
};

export const getRelatiesMuteerRelatieByIdMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof relatiesMuteerRelatieById>>,
    TError,
    RelatiesMuteerRelatieByIdMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof relatiesMuteerRelatieById>>,
  TError,
  RelatiesMuteerRelatieByIdMutationVariables,
  TContext
> => {
  const mutationKey = ['relatiesMuteerRelatieById'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof relatiesMuteerRelatieById>>,
    RelatiesMuteerRelatieByIdMutationVariables
  > = (props) => {
    const { relatienummer, data } = props ?? {};

    return relatiesMuteerRelatieById(relatienummer, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RelatiesMuteerRelatieByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof relatiesMuteerRelatieById>>
>;
export type RelatiesMuteerRelatieByIdMutationBody =
  | CrmRelationsZakelijkeRelatieDto
  | CrmRelationsParticuliereRelatieDto
  | undefined;
export type RelatiesMuteerRelatieByIdMutationError = ErrorType<void>;
export type RelatiesMuteerRelatieByIdMutationVariables = {
  relatienummer: number | undefined | null;
  data?: CrmRelationsZakelijkeRelatieDto | CrmRelationsParticuliereRelatieDto;
};

/**
 * @summary Muteer een relatie.
 */
export const useRelatiesMuteerRelatieById = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof relatiesMuteerRelatieById>>,
      TError,
      RelatiesMuteerRelatieByIdMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof relatiesMuteerRelatieById>>,
  TError,
  RelatiesMuteerRelatieByIdMutationVariables,
  TContext
> => {
  return useMutation(getRelatiesMuteerRelatieByIdMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.RelatieInzien</li></ul>
 * @summary Haal een specifieke relatie op op basis van een relatie id.
 */
export const relatiesGetRelationById = (
  id: MaybeRefOrGetter<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  id = toValue(id);

  return customInstance<Result1OfCrmRelationsRelationDto>(
    { url: `/api/v1/relaties/${id}/relatieid`, method: 'GET', signal },
    options,
  );
};

export const getRelatiesGetRelationByIdQueryKey = (
  id: MaybeRefOrGetter<string | undefined | null>,
) => {
  return ['api', 'v1', 'relaties', id, 'relatieid'] as const;
};

export const getRelatiesGetRelationByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof relatiesGetRelationById>>,
  TError = ErrorType<void>,
>(
  id: MaybeRefOrGetter<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof relatiesGetRelationById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getRelatiesGetRelationByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof relatiesGetRelationById>>> = ({
    signal,
  }) => relatiesGetRelationById(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof relatiesGetRelationById>>, TError, TData>;
};

export type RelatiesGetRelationByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof relatiesGetRelationById>>
>;
export type RelatiesGetRelationByIdQueryError = ErrorType<void>;

/**
 * @summary Haal een specifieke relatie op op basis van een relatie id.
 */

export function useRelatiesGetRelationById<
  TData = Awaited<ReturnType<typeof relatiesGetRelationById>>,
  TError = ErrorType<void>,
>(
  id: MaybeRefOrGetter<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof relatiesGetRelationById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRelatiesGetRelationByIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.RelatieInzien</li></ul>
 * @summary Hiermee kan je zoeken naar relaties van een bepaalde adviseur
 */
export const relatiesGetBy = (
  params?: MaybeRefOrGetter<RelatiesGetByParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = toValue(params);

  return customInstance<CollectionResultOfCrmRelationsZoekRelatiesByDto>(
    { url: `/api/v1/relaties`, method: 'GET', params, signal },
    options,
  );
};

export const getRelatiesGetByQueryKey = (params?: MaybeRefOrGetter<RelatiesGetByParams>) => {
  return ['api', 'v1', 'relaties', ...(params ? [params] : [])] as const;
};

export const getRelatiesGetByQueryOptions = <
  TData = Awaited<ReturnType<typeof relatiesGetBy>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<RelatiesGetByParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof relatiesGetBy>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getRelatiesGetByQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof relatiesGetBy>>> = ({ signal }) =>
    relatiesGetBy(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof relatiesGetBy>>,
    TError,
    TData
  >;
};

export type RelatiesGetByQueryResult = NonNullable<Awaited<ReturnType<typeof relatiesGetBy>>>;
export type RelatiesGetByQueryError = ErrorType<void>;

/**
 * @summary Hiermee kan je zoeken naar relaties van een bepaalde adviseur
 */

export function useRelatiesGetBy<
  TData = Awaited<ReturnType<typeof relatiesGetBy>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<RelatiesGetByParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof relatiesGetBy>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRelatiesGetByQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.RelatieAanmaken</li></ul>
 * @summary Maak een nieuwe relatie aan.
 */
export const relatiesMaakRelatie = (
  crmRelationsZakelijkeRelatieDtoCrmRelationsParticuliereRelatieDto?: MaybeRefOrGetter<
    CrmRelationsZakelijkeRelatieDto | CrmRelationsParticuliereRelatieDto
  >,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  crmRelationsZakelijkeRelatieDtoCrmRelationsParticuliereRelatieDto = toValue(
    crmRelationsZakelijkeRelatieDtoCrmRelationsParticuliereRelatieDto,
  );

  return customInstance<number>(
    {
      url: `/api/v1/relaties`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: crmRelationsZakelijkeRelatieDtoCrmRelationsParticuliereRelatieDto,
      signal,
    },
    options,
  );
};

export const getRelatiesMaakRelatieMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof relatiesMaakRelatie>>,
    TError,
    RelatiesMaakRelatieMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof relatiesMaakRelatie>>,
  TError,
  RelatiesMaakRelatieMutationVariables,
  TContext
> => {
  const mutationKey = ['relatiesMaakRelatie'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof relatiesMaakRelatie>>,
    RelatiesMaakRelatieMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return relatiesMaakRelatie(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RelatiesMaakRelatieMutationResult = NonNullable<
  Awaited<ReturnType<typeof relatiesMaakRelatie>>
>;
export type RelatiesMaakRelatieMutationBody =
  | CrmRelationsZakelijkeRelatieDto
  | CrmRelationsParticuliereRelatieDto
  | undefined;
export type RelatiesMaakRelatieMutationError = ErrorType<void>;
export type RelatiesMaakRelatieMutationVariables = {
  data?: CrmRelationsZakelijkeRelatieDto | CrmRelationsParticuliereRelatieDto;
};

/**
 * @summary Maak een nieuwe relatie aan.
 */
export const useRelatiesMaakRelatie = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof relatiesMaakRelatie>>,
      TError,
      RelatiesMaakRelatieMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof relatiesMaakRelatie>>,
  TError,
  RelatiesMaakRelatieMutationVariables,
  TContext
> => {
  return useMutation(getRelatiesMaakRelatieMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.RelatieInzien</li></ul>
 * @summary Endpoint voor specifiek het relatieoverzicht
 */
export const relatiesGetOverzicht = (
  params?: MaybeRefOrGetter<RelatiesGetOverzichtParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = toValue(params);

  return customInstance<CollectionResultOfSUREbusinessCCSPublisherFeaturesRelatieFindRelatiesDto>(
    { url: `/api/v1/relaties/overzicht`, method: 'GET', params, signal },
    options,
  );
};

export const getRelatiesGetOverzichtQueryKey = (
  params?: MaybeRefOrGetter<RelatiesGetOverzichtParams>,
) => {
  return ['api', 'v1', 'relaties', 'overzicht', ...(params ? [params] : [])] as const;
};

export const getRelatiesGetOverzichtQueryOptions = <
  TData = Awaited<ReturnType<typeof relatiesGetOverzicht>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<RelatiesGetOverzichtParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof relatiesGetOverzicht>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getRelatiesGetOverzichtQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof relatiesGetOverzicht>>> = ({ signal }) =>
    relatiesGetOverzicht(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof relatiesGetOverzicht>>,
    TError,
    TData
  >;
};

export type RelatiesGetOverzichtQueryResult = NonNullable<
  Awaited<ReturnType<typeof relatiesGetOverzicht>>
>;
export type RelatiesGetOverzichtQueryError = ErrorType<void>;

/**
 * @summary Endpoint voor specifiek het relatieoverzicht
 */

export function useRelatiesGetOverzicht<
  TData = Awaited<ReturnType<typeof relatiesGetOverzicht>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<RelatiesGetOverzichtParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof relatiesGetOverzicht>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRelatiesGetOverzichtQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.RelatieInzien</li></ul>
 * @summary Endpoint voor specifiek het relatieoverzicht tellertje
 */
export const relatiesGetOverzichtCount = (
  params?: MaybeRefOrGetter<RelatiesGetOverzichtCountParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = toValue(params);

  return customInstance<Result1OfSystemInt32>(
    { url: `/api/v1/relaties/overzicht-count`, method: 'GET', params, signal },
    options,
  );
};

export const getRelatiesGetOverzichtCountQueryKey = (
  params?: MaybeRefOrGetter<RelatiesGetOverzichtCountParams>,
) => {
  return ['api', 'v1', 'relaties', 'overzicht-count', ...(params ? [params] : [])] as const;
};

export const getRelatiesGetOverzichtCountQueryOptions = <
  TData = Awaited<ReturnType<typeof relatiesGetOverzichtCount>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<RelatiesGetOverzichtCountParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof relatiesGetOverzichtCount>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getRelatiesGetOverzichtCountQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof relatiesGetOverzichtCount>>> = ({
    signal,
  }) => relatiesGetOverzichtCount(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof relatiesGetOverzichtCount>>,
    TError,
    TData
  >;
};

export type RelatiesGetOverzichtCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof relatiesGetOverzichtCount>>
>;
export type RelatiesGetOverzichtCountQueryError = ErrorType<void>;

/**
 * @summary Endpoint voor specifiek het relatieoverzicht tellertje
 */

export function useRelatiesGetOverzichtCount<
  TData = Awaited<ReturnType<typeof relatiesGetOverzichtCount>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<RelatiesGetOverzichtCountParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof relatiesGetOverzichtCount>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRelatiesGetOverzichtCountQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.RelatieInzien</li></ul>
 * @summary Uitgebreid zoeken voor het relatieoverzicht; vervangt achter een toggle het legacy /net/relation/search.
 */
export const relatiesGetOverzichtUitgebreid = (
  params?: MaybeRefOrGetter<RelatiesGetOverzichtUitgebreidParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = toValue(params);

  return customInstance<CollectionResultOfSUREbusinessCCSPublisherFeaturesRelatieFindRelatiesDto>(
    {
      url: `/api/v1/relaties/overzicht-uitgebreid`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getRelatiesGetOverzichtUitgebreidQueryKey = (
  params?: MaybeRefOrGetter<RelatiesGetOverzichtUitgebreidParams>,
) => {
  return ['api', 'v1', 'relaties', 'overzicht-uitgebreid', ...(params ? [params] : [])] as const;
};

export const getRelatiesGetOverzichtUitgebreidQueryOptions = <
  TData = Awaited<ReturnType<typeof relatiesGetOverzichtUitgebreid>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<RelatiesGetOverzichtUitgebreidParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof relatiesGetOverzichtUitgebreid>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getRelatiesGetOverzichtUitgebreidQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof relatiesGetOverzichtUitgebreid>>> = ({
    signal,
  }) => relatiesGetOverzichtUitgebreid(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof relatiesGetOverzichtUitgebreid>>,
    TError,
    TData
  >;
};

export type RelatiesGetOverzichtUitgebreidQueryResult = NonNullable<
  Awaited<ReturnType<typeof relatiesGetOverzichtUitgebreid>>
>;
export type RelatiesGetOverzichtUitgebreidQueryError = ErrorType<void>;

/**
 * @summary Uitgebreid zoeken voor het relatieoverzicht; vervangt achter een toggle het legacy /net/relation/search.
 */

export function useRelatiesGetOverzichtUitgebreid<
  TData = Awaited<ReturnType<typeof relatiesGetOverzichtUitgebreid>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<RelatiesGetOverzichtUitgebreidParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof relatiesGetOverzichtUitgebreid>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRelatiesGetOverzichtUitgebreidQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.RelatieInzien</li></ul>
 * @summary Tellertje bij het uitgebreid zoeken voor het relatieoverzicht.
 */
export const relatiesGetOverzichtUitgebreidCount = (
  params?: MaybeRefOrGetter<RelatiesGetOverzichtUitgebreidCountParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = toValue(params);

  return customInstance<Result1OfSystemInt32>(
    {
      url: `/api/v1/relaties/overzicht-uitgebreid-count`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getRelatiesGetOverzichtUitgebreidCountQueryKey = (
  params?: MaybeRefOrGetter<RelatiesGetOverzichtUitgebreidCountParams>,
) => {
  return [
    'api',
    'v1',
    'relaties',
    'overzicht-uitgebreid-count',
    ...(params ? [params] : []),
  ] as const;
};

export const getRelatiesGetOverzichtUitgebreidCountQueryOptions = <
  TData = Awaited<ReturnType<typeof relatiesGetOverzichtUitgebreidCount>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<RelatiesGetOverzichtUitgebreidCountParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof relatiesGetOverzichtUitgebreidCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getRelatiesGetOverzichtUitgebreidCountQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof relatiesGetOverzichtUitgebreidCount>>> = ({
    signal,
  }) => relatiesGetOverzichtUitgebreidCount(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof relatiesGetOverzichtUitgebreidCount>>,
    TError,
    TData
  >;
};

export type RelatiesGetOverzichtUitgebreidCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof relatiesGetOverzichtUitgebreidCount>>
>;
export type RelatiesGetOverzichtUitgebreidCountQueryError = ErrorType<void>;

/**
 * @summary Tellertje bij het uitgebreid zoeken voor het relatieoverzicht.
 */

export function useRelatiesGetOverzichtUitgebreidCount<
  TData = Awaited<ReturnType<typeof relatiesGetOverzichtUitgebreidCount>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<RelatiesGetOverzichtUitgebreidCountParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof relatiesGetOverzichtUitgebreidCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRelatiesGetOverzichtUitgebreidCountQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.RelatieInzien</li></ul>
 * @summary Geeft de mogelijke rechtsvormopties terug.
 */
export const relatiesGetRechtsvormopties = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CollectionResultOfCrmRelationsGetRechtsvormOptiesDto>(
    { url: `/api/v1/relaties/rechtsvormopties`, method: 'GET', signal },
    options,
  );
};

export const getRelatiesGetRechtsvormoptiesQueryKey = () => {
  return ['api', 'v1', 'relaties', 'rechtsvormopties'] as const;
};

export const getRelatiesGetRechtsvormoptiesQueryOptions = <
  TData = Awaited<ReturnType<typeof relatiesGetRechtsvormopties>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof relatiesGetRechtsvormopties>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getRelatiesGetRechtsvormoptiesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof relatiesGetRechtsvormopties>>> = ({
    signal,
  }) => relatiesGetRechtsvormopties(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof relatiesGetRechtsvormopties>>,
    TError,
    TData
  >;
};

export type RelatiesGetRechtsvormoptiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof relatiesGetRechtsvormopties>>
>;
export type RelatiesGetRechtsvormoptiesQueryError = ErrorType<void>;

/**
 * @summary Geeft de mogelijke rechtsvormopties terug.
 */

export function useRelatiesGetRechtsvormopties<
  TData = Awaited<ReturnType<typeof relatiesGetRechtsvormopties>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof relatiesGetRechtsvormopties>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRelatiesGetRechtsvormoptiesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.RelatieInzien</li></ul>
 * @summary Geeft de kredietstatus van een relatie terug
 */
export const relatiesGetKredietstatus = (
  relatienummer: MaybeRefOrGetter<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  relatienummer = toValue(relatienummer);

  return customInstance<Result1OfCrmRelationsGetRelatieKredietstatusDto>(
    {
      url: `/api/v1/relaties/${relatienummer}/kredietstatus`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getRelatiesGetKredietstatusQueryKey = (
  relatienummer: MaybeRefOrGetter<number | undefined | null>,
) => {
  return ['api', 'v1', 'relaties', relatienummer, 'kredietstatus'] as const;
};

export const getRelatiesGetKredietstatusQueryOptions = <
  TData = Awaited<ReturnType<typeof relatiesGetKredietstatus>>,
  TError = ErrorType<void | Result1OfManagementModelsEmpty>,
>(
  relatienummer: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof relatiesGetKredietstatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getRelatiesGetKredietstatusQueryKey(relatienummer);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof relatiesGetKredietstatus>>> = ({
    signal,
  }) => relatiesGetKredietstatus(relatienummer, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(
      () => toValue(relatienummer) !== null && toValue(relatienummer) !== undefined,
    ),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof relatiesGetKredietstatus>>, TError, TData>;
};

export type RelatiesGetKredietstatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof relatiesGetKredietstatus>>
>;
export type RelatiesGetKredietstatusQueryError = ErrorType<void | Result1OfManagementModelsEmpty>;

/**
 * @summary Geeft de kredietstatus van een relatie terug
 */

export function useRelatiesGetKredietstatus<
  TData = Awaited<ReturnType<typeof relatiesGetKredietstatus>>,
  TError = ErrorType<void | Result1OfManagementModelsEmpty>,
>(
  relatienummer: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof relatiesGetKredietstatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRelatiesGetKredietstatusQueryOptions(relatienummer, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.RelatieInzien</li></ul>
 * @summary Geeft historie van wijzigingen aan relatie en bijbehorende contactpersonen terug.
 */
export const relatiesGetRelatieLogs = (
  relatienummer: MaybeRefOrGetter<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  relatienummer = toValue(relatienummer);

  return customInstance<CollectionResultOfCrmRelationsLoggingRelatieLog>(
    { url: `/api/v1/relaties/${relatienummer}/logs`, method: 'GET', signal },
    options,
  );
};

export const getRelatiesGetRelatieLogsQueryKey = (
  relatienummer: MaybeRefOrGetter<number | undefined | null>,
) => {
  return ['api', 'v1', 'relaties', relatienummer, 'logs'] as const;
};

export const getRelatiesGetRelatieLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof relatiesGetRelatieLogs>>,
  TError = ErrorType<void>,
>(
  relatienummer: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof relatiesGetRelatieLogs>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getRelatiesGetRelatieLogsQueryKey(relatienummer);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof relatiesGetRelatieLogs>>> = ({ signal }) =>
    relatiesGetRelatieLogs(relatienummer, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(
      () => toValue(relatienummer) !== null && toValue(relatienummer) !== undefined,
    ),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof relatiesGetRelatieLogs>>, TError, TData>;
};

export type RelatiesGetRelatieLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof relatiesGetRelatieLogs>>
>;
export type RelatiesGetRelatieLogsQueryError = ErrorType<void>;

/**
 * @summary Geeft historie van wijzigingen aan relatie en bijbehorende contactpersonen terug.
 */

export function useRelatiesGetRelatieLogs<
  TData = Awaited<ReturnType<typeof relatiesGetRelatieLogs>>,
  TError = ErrorType<void>,
>(
  relatienummer: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof relatiesGetRelatieLogs>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRelatiesGetRelatieLogsQueryOptions(relatienummer, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
